import React from 'react';
import { TimelineContainer, TimelineItem } from 'pods/timeline';
import { DossierStep, useDossierContext } from 'common-app/dossier';
export const DossierTimeline = () => {
    const { dossier } = useDossierContext();
    const block = React.useMemo(() => {
        const step = dossier === null || dossier === void 0 ? void 0 : dossier.step;
        switch (step) {
            case DossierStep.SIGNATORIES:
                return 0;
            case DossierStep.OCCUPANTS:
                return 1;
            case DossierStep.SUMMARY:
            case DossierStep.EXPLICATIONS:
                return 2;
            case DossierStep.DOCUMENTS:
            case DossierStep.VALIDATED:
                return 3;
            default:
                return -1;
        }
    }, [dossier]);
    const step = 0;
    return (React.createElement(React.Fragment, null, block !== -1 && (React.createElement(TimelineContainer, null,
        React.createElement(TimelineItem, { title: 'Titulaires', index: 0, block: block, step: step, steps: [] }),
        React.createElement(TimelineItem, { title: 'Occupants non titulaires', cssClass: 'timeline-twoLines', index: 1, block: block, step: step, steps: [] }),
        React.createElement(TimelineItem, { title: 'Récapitulatif', index: 2, block: block, step: step, steps: [] }),
        React.createElement(TimelineItem, { title: 'Transmettre vos justificatifs', index: 3, block: block, step: step, steps: [] })))));
};
